import { Component, Inject, OnInit, NgModule } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GetRequestActivityByIdGQL } from '../../../../generated/cloudapigql';
import { DatePipe } from '@angular/common';

// export interface DialogData {
//     title: [];
//     type: number;
//     amount: number;
//     att: any [];
// }

@Component({
    selector: 'activity-detail-dialog',
    templateUrl: 'activity-detail-dialog.html',
    styleUrls: ['activity-detail-dialog.scss']
})

export class ActivityDetailDialog implements OnInit {
    result: any;

    constructor(
        public dialogRef: MatDialogRef<ActivityDetailDialog>,
        private getRequestActivityByIdGQL: GetRequestActivityByIdGQL,
        @Inject(MAT_DIALOG_DATA) private _data: any
    ) {
        if (this._data != null) {
            let requestActivityId = this._data;

            if(requestActivityId){

                this.getRequestActivityByIdGQL.fetch({
                  ActivityId:requestActivityId
                }).subscribe(x=>{
                  this.result = x.data.requestActivityById;
                  
                  if(this.result.requestFollowUp){
                    this.result.categoryType = "Follow Up";
                  }else if(this.result.requestQuotation){
                    this.result.categoryType = "Quotation";
                  }else if(this.result.requestEstimation){
                    this.result.categoryType = "Estimated Construction";
                  }else{
                    this.result.categoryType = "Assignment";
                   
                  }
                },error=>{
                  console.error(error);
                })
          
              }
        }
    }

    ngOnInit() {
    }

    downloadQuotation(url: string) {
        window.open(url);
    }

}
